<template>
  <div>
    <a-form :form="form" @submit="saveColumnData">
      <a-form-item
        label="角色名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'role_name',
            {
              initialValue: roleDetail.role_name,
              rules: [{ required: true, message: '请输入角色名称' }]
            }
          ]"
          placeholder="请输入角色名称"/>
      </a-form-item>
      <a-form-item
        :required="true"
        label="状态"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-radio-group v-model="roleDetail.role_status">
          <a-radio-button v-if="status.id !== ''" v-for="status in statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="备注"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          v-decorator="[
            'role_desc',
            {
              initialValue: roleDetail.role_desc
            }
          ]"
          :rows="6"
          placeholder="请输入备注"/>
      </a-form-item>
      <a-form-item :wrapperCol="{span: 12, offset: 9}">
        <a-button style="margin-right:20px" html-type="submit" type="primary">保存</a-button>
        <a-button @click="onClose">取消</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { postUpdateRole } from '@/api/role'
import _ from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: Number,
      default: 0
    },
    roleDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 抽屉加载
      loading: true,
      // 添加角色数据
      roleData: {
        role_id: '',
        role_name: '',
        role_desc: '',
        role_status: 'NORMAL'
      },
      statusDict: [
        { id: 'NORMAL', name: '正常' },
        { id: 'FORBIDDEN', name: '禁用' }
      ]
    }
  },
  methods: {
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.roleData.role_id = this.roleId
          this.roleData.role_status = this.roleDetail.role_status
          this.roleData.role_name = fieldsValue['role_name']
          this.roleData.role_desc = fieldsValue['role_desc']
          postUpdateRole(this.roleData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.$message.success('保存成功')
              this.$emit('finish')
            }
          })
        }
      })
    }
  },
  created () {
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
